// src/index.js
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// ✅ local files in THIS project must be relative
import "./assets/scss/now-ui-kit.scss";
import "./assets/scss/custom-overrides.scss";
import "./assets/css/tokai-overrides.css";

// ✅ bootstrap works ONLY if installed
import "bootstrap/dist/css/bootstrap.min.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={null}>
    <App />
  </Suspense>
);
